/* event on load vanilla js */

function scrollToAnchor() {
  const anchor = window.location.hash.replace("#", "");
  if (anchor) {
    const target = document.getElementById(anchor);
    if (target) {
      let scroll_top = target.getBoundingClientRect().top;

      window.scrollTo({
        top: scroll_top + window.scrollY - 100,
        behavior: "smooth",
      });
    }
  }
}

window.addEventListener("load", function () {
  scrollToAnchor();

  const checkbox_svg =
    '<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.5C0 6.9813 2.0187 9 4.5 9C6.9813 9 9 6.9813 9 4.5C9 2.0187 6.9813 0 4.5 0C2.0187 0 0 2.0187 0 4.5ZM6.8432 3.6932C7.01893 3.51746 7.01893 3.23254 6.8432 3.0568C6.66746 2.88107 6.38254 2.88107 6.2068 3.0568L4.05 5.2136L3.0182 4.1818C2.84246 4.00607 2.55754 4.00607 2.3818 4.1818C2.20607 4.35754 2.20607 4.64246 2.3818 4.8182L3.7318 6.1682C3.90754 6.34393 4.19246 6.34393 4.3682 6.1682L6.8432 3.6932Z" fill="#45C391"/></svg>';
  const source_tabs = document.querySelectorAll("[open-tab]");

  let titles = document.querySelectorAll(
    ".main-article__content :is(h2,h3), .fullscreen-hero__content-text :is(h2,h3)"
  );

  let index = 0;
  titles.forEach(function (title) {
    title.setAttribute("id", index++);
  });

  console.log(titles);

  let buttons_summary = document.querySelectorAll("button[data-title-id]");

  let i = 0;
  let indexChar = "a";

  buttons_summary.forEach(function (button) {
    let id = button.getAttribute("data-title-id");

    if (
      document.getElementById(id)?.closest(".fullscreen-hero") == null &&
      document.getElementById(id)?.closest(".main-article__related-articles") ==
      null &&
      document.getElementById(id)?.closest(".main-article__product") == null &&
      document.getElementById(id)?.closest(".main-article__collection") == null
    ) {
      button.addEventListener("click", function (e) {
        const target = e.currentTarget;
        const id = target.getAttribute("data-title-id");
        const title = document.getElementById(id);
        console.log(title);
        let scroll_top = title.getBoundingClientRect().top;

        window.scrollTo({
          top: scroll_top + window.scrollY - 100,
          behavior: "smooth",
        });
      });

      if (document.getElementById(id)?.outerHTML.indexOf("h2") > -1) {
        i++;
        button.innerHTML = "<strong>" + i + ".</strong> " + button.innerHTML;
        indexChar = "a";
      } else {
        button.innerHTML =
          "<strong>" + indexChar + ".</strong> " + button.innerHTML;
        button.style.marginLeft = "12px";
        indexChar = String.fromCharCode(indexChar.charCodeAt(0) + 1);
      }
    } else {
      button.remove();
    }
  });

  let open_summary = document.querySelector(".article-summary__title");

  if (open_summary) {
    open_summary.addEventListener("click", function (e) {
      const target = e.currentTarget;
      const summary = document.querySelector(".article-summary");
      summary.classList.toggle("actif");

      target.dataset.buttonChar == "+"
        ? (target.dataset.buttonChar = "-")
        : (target.dataset.buttonChar = "+");
    });
  }

  source_tabs.forEach(function (link) {
    link.innerHTML = link.innerHTML + checkbox_svg;

    link.addEventListener("click", function (e) {
      const target = e.currentTarget;

      if (document.querySelector(".source-code")) {
        document.querySelector(".source-code").remove();
      }

      var template = `
                <div class="source-code__header">
                    <div class="source-code__header__title">
                        <h3>
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.5C0 11.6355 3.3645 15 7.5 15C11.6355 15 15 11.6355 15 7.5C15 3.3645 11.6355 0 7.5 0C3.3645 0 0 3.3645 0 7.5ZM11.4053 6.15533C11.6982 5.86244 11.6982 5.38756 11.4053 5.09467C11.1124 4.80178 10.6376 4.80178 10.3447 5.09467L6.75 8.68934L5.03033 6.96967C4.73744 6.67678 4.26256 6.67678 3.96967 6.96967C3.67678 7.26256 3.67678 7.73744 3.96967 8.03033L6.21967 10.2803C6.51256 10.5732 6.98744 10.5732 7.28033 10.2803L11.4053 6.15533Z" fill="#45C391"/> </svg>
                            Source vérifiée
                        </h3>
                    </div>
                    <div class="source-code__body">
                        <div class="source-code__body__content">
                            <div class="source-code__body__content__title">
                                <h4>{tite}</h4>
                            </div>
                            <div class="source-code__body__content">
                                <p>{content}</p>
                            </div>
                            <a class="btn-card-main panda-btn btn-animation" target="_blank" href="{url}">Voir la source</a>
                        </div>
                    </div>
                    <div class="source-code__header__close">
                        <button class="close-source-code">
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M19.2953 0.000618132L0 19.2925L0.706613 19.9995L20.0019 0.707601L19.2953 0.000618132Z" fill="black"/> <path d="M0.710825 -1.11587e-05L0.00408936 0.706848L19.2935 19.9997L20.0003 19.2928L0.710825 -1.11587e-05Z" fill="black"/> </svg>
                        </button>
                    </div>
            `;

      const id = target.getAttribute("open-tab").replace("open-src=", "");

      var src = null;
      // get elem in array article_sources matching id
      for (var i = 0; i < article_sources.length; i++) {
        if (article_sources[i].id == id) {
          src = article_sources[i];
        }
      }

      template = template.replace("{tite}", src.title);
      template = template.replace("{content}", src.content);
      template = template.replace("{url}", src.url);

      const source_code = document.createElement("div");
      source_code.classList.add("source-code");

      if (src.url.length <= 1) {
        source_code.classList.add("source-code--no-link");
      }

      source_code.innerHTML = template;

      target.append(source_code);

      // check if window width is < 990px
      if (window.innerWidth < 990) {
        document.querySelector("body").classList.add("source-overflow");
      } else {
        var total =
          document.querySelector(".source-code").getBoundingClientRect().left +
          document.querySelector(".source-code").clientWidth;
        var windowWidth = window.innerWidth;
        console.log(total, windowWidth);
        if (total > windowWidth) {
          document
            .querySelector(".source-code")
            .setAttribute(
              "style",
              `transform: translateY(-30px) translateX(-${total - windowWidth + 20
              }px)`
            );
        }
      }
    });

    document.querySelector("body").addEventListener("click", function (e) {
      if (document.querySelector(".source-code")) {
        console.log(e.target);
        if (
          !e.target.classList.contains("panda-btn") &&
          (e.target.classList.contains("source-code__header__close") ||
            e.target.closest(".source-code__header__close") ||
            (!e.target.closest(".source-code") &&
              !e.target.getAttribute("open-tab") &&
              !e.currentTarget.getAttribute("open-tab")))
        ) {
          document.querySelector(".source-code").remove();
          document.querySelector("body").classList.remove("source-overflow");
        }
      }
    });
  });

  // document
  //   .querySelectorAll("article a:not(.breadcrumbs__link), .fullscreen-hero a")
  //   .forEach(function (link) {
  //     let url = link.getAttribute("href");
  //     if (url) {
  //       url += url.indexOf("?") > -1 ? "&" : "?";
  //     }

  //     if (document.querySelector("article")) {
  //       let utm_campaign = document
  //         .querySelector("article")
  //         .getAttribute("data-utm-campaign");
  //       let utm_medium = document
  //         .querySelector("article")
  //         .getAttribute("data-utm-medium");
  //       let utm_source = document
  //         .querySelector("article")
  //         .getAttribute("data-utm-source");
  //       let handle = document
  //         .querySelector("article")
  //         .getAttribute("data-article-handle");

  //       if (!utm_campaign || utm_campaign.length == 0) utm_campaign = handle;
  //       if (!utm_medium || utm_medium.length == 0) utm_medium = "blog";
  //       if (!utm_source || utm_source.length == 0) utm_source = "pandatea";

  //       url += `utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`;

  //       if (link.getAttribute("open-tab") == null)
  //         link.setAttribute("href", url);
  //     }
  //   });

  initFilterByFirstLetter();
});

function initFilterByFirstLetter() {
  const items = document.querySelectorAll(
    ".list-item-article[data-first-letter]"
  );
  const lettersFilter = document.querySelectorAll(
    ".letter-filter[data-letter]"
  );

  if (items.length > 0 && lettersFilter) {
    lettersFilter.forEach(function (letter) {
      letter.addEventListener("click", function (e) {
        e.preventDefault();

        let letter = e.currentTarget.getAttribute("data-letter");

        lettersFilter.forEach(function (l) {
          l.classList.remove("actif");
          if (l.dataset.letter == letter) {
            l.classList.add("actif");
          } else if (letter == "TOUS" && l.dataset.letter == "TOUS") {
            l.classList.add("actif");
          }
        });

        items.forEach(function (item) {
          if (
            item.getAttribute("data-first-letter") == letter ||
            letter == "TOUS"
          ) {
            item.classList.remove("hidden");
          } else {
            item.classList.add("hidden");
          }
        });
      });
    });
  }
}

function resizeMasonryItem(item) {
  /* Get the grid object, its row-gap, and the size of its implicit rows */
  var grid = document.getElementsByClassName("masonry")[0],
    rowGap = parseInt(
      window.getComputedStyle(grid).getPropertyValue("grid-row-gap")
    ),
    rowHeight = parseInt(
      window.getComputedStyle(grid).getPropertyValue("grid-auto-rows")
    );

  /*
   * Spanning for any brick = S
   * Grid's row-gap = G
   * Size of grid's implicitly create row-track = R
   * Height of item content = H
   * Net height of the item = H1 = H + G
   * Net height of the implicit row-track = T = G + R
   * S = H1 / T
   */
  var rowSpan = Math.ceil(
    (item.querySelector(".masonry-content").getBoundingClientRect().height +
      rowGap) /
    (rowHeight + rowGap)
  );

  /* Set the spanning as calculated above (S) */
  item.style.gridRowEnd = "span " + rowSpan;

  /* Make the images take all the available space in the cell/item */
  item.querySelector(".masonry-content").style.height = rowSpan * 10 + "px";
}

/**
 * Apply spanning to all the masonry items
 *
 * Loop through all the items and apply the spanning to them using
 * `resizeMasonryItem()` function.
 *
 * @uses resizeMasonryItem
 */
function resizeAllMasonryItems() {
  // Get all item class objects in one list
  var allItems = document.getElementsByClassName("masonry-item");

  /*
   * Loop through the above list and execute the spanning function to
   * each list-item (i.e. each masonry item)
   */
  for (var i = 0; i > allItems.length; i++) {
    resizeMasonryItem(allItems[i]);
  }
}

/**
 * Resize the items when all the images inside the masonry grid
 * finish loading. This will ensure that all the content inside our
 * masonry items is visible.
 *
 * @uses ImagesLoaded
 * @uses resizeMasonryItem
 */
function waitForImages() {
  var allItems = document.getElementsByClassName("masonry-item");
  for (var i = 0; i < allItems.length; i++) {
    imagesLoaded(allItems[i], function (instance) {
      var item = instance.elements[0];
      resizeMasonryItem(item);
    });
  }
}

/* Resize all the grid items on the load and resize events */
var masonryEvents = ["load", "resize"];
masonryEvents.forEach(function (event) {
  window.addEventListener(event, resizeAllMasonryItems);
});

/* Do a resize once more when all the images finish loading */
waitForImages();
